import React, {useState} from 'react';
import './AdminDashboard.scss'
import PurpleTab from "./PurpleTab";
import {S360_charts} from "./constants/S360_constants";
import ResourcePupilUsageYearSummary from "./ResourcePupilUsageYearSummary";
import ResourceUsagePie from "./ResourceUsagePie";
import UsageYearSummary from "./UsageYearSummary";
import UsagePie from "./UsagePie";
import ResourcePupilUsageBySchool from "./ResourcePupilUsageBySchool";
import DropdownUsageReports from "./ui/DropdownUsageReports";
import phpVars from 'phpVars';

const UsageGraphSelector = (props) =>
{
    const [ report_id, setReportId ] = useState ( 0) ;

    const onUsageReportDropdownChange = ( evt, options ) =>
    {
        if ( options.action === 'select-option')
        {
            const value = evt.value;
            setReportId ( value) ;
        }
    };

    const displaySelectedGraph = ( ) =>
    {
        switch (report_id){
            case S360_charts.RESOURCE_USAGE_BY_MONTH:
                return <ResourcePupilUsageYearSummary key='chart1' title='' school_id={props.school_id} resource_type='shared'/>

            case S360_charts.RESOURCE_USAGE_TOTALS:
                return <ResourceUsagePie key='chart2' title='' school_id = {props.school_id} resource_type='shared'/>

            case S360_charts.S360_USAGE_BY_MONTH:
                return <UsageYearSummary key='chart3' title='' school_id={props.school_id} resource_type='shared'/>

            case S360_charts.S360_USAGE_TOTALS:
                return <UsagePie key='chart4' title='' school_id = {props.school_id} resource_type='shared'/>

            case S360_charts.RESOURCE_USAGE_BY_SCHOOL:
                return <ResourcePupilUsageBySchool key='chart5' title=''/>
        }
    };

    return (
        <PurpleTab title='Pupil Activity'>
            <DropdownUsageReports onChange={onUsageReportDropdownChange}
                                  id='InputUsageReportDropdown'
                                  defaultValue={0}
                                  isClearable={false}
                                  value={report_id}
                                  readOnly=''
                                  key='InputUsageReportDropdown'
                                  menuPlacement={'top'}
                                  renderErrorDiv={false}
                                  user_type={phpVars.user_type}/>

            {displaySelectedGraph()}

        </PurpleTab>
    )
}

export default UsageGraphSelector;

UsageGraphSelector.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default',
        data: {}
    }